import { render, staticRenderFns } from "./IconSwitchAdmin.vue?vue&type=template&id=5c027453"
import script from "./IconSwitchAdmin.vue?vue&type=script&lang=js"
export * from "./IconSwitchAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports